import React, { useEffect, useState } from 'react'
import ButtonBuyQuantity from './UI/button/ButtonBuyQuantity'
import _ from 'lodash'
import { selectPartsInBasket } from './table/partsInBasketSlice'
import { useSelector } from 'react-redux'

const TopPart = ({ part, name, icon, type, isHide }) => {
    const [hide, setHide] = useState('')

    const toggleShow = () => {
        if (hide.length) setHide('')
        else setHide('hide')
    }

    useEffect(() => {
        if (isHide) setHide('hide')
        else setHide('')
    }, [isHide, setHide])

    const partsInBasket = useSelector(selectPartsInBasket)

    return (
        <div className={['top-part', hide].join(' ')}>
            <div className="top_part__header">
                <div className={['top_part__header-name', icon].join(' ')}>{name}</div>
                {type ? <div className="top_part__header-type">{type}</div> : <></>}
                <div className="top_part__header-arrow" onClick={toggleShow}>
                    <svg
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z" fill="black" />
                    </svg>
                </div>
            </div>
            <div className="top_part__body">
                <div className="top_part__body-name">
                    <span className="article">{part.original_article}</span> {part.brand_title}
                </div>
                <div className="top_part__body-info">
                    <div className="top_part__body-quantity">{part.quantity}</div>
                    <div className="top_part__body-delivery">{part.delivery_time}</div>
                    <div className="top_part__body-price">{part.price}</div>
                    <div className="top_part__body-action">
                        <ButtonBuyQuantity
                            part={part}
                            basketInfo={
                                _.has(partsInBasket, [part.basket_hash])
                                    ? partsInBasket[part.basket_hash]
                                    : 0
                            }
                            showQuantitySelect={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopPart
